import React, { useEffect, useState } from "react";
import {
  LinkageViewTable,
  LinkageIdInput,
  LinkageSelectInput,
  LinkageTextInput,
} from "./components";

const LinkageTable = ({
  input,
  formApi,
  formValues,
  schemaProps: {
    linkages: { fromFieldArray, type },
  },
  schemaProps,
  row,
}) => {
  // Set linkable data
  const [linkableDataset, setLinkableDataset] = useState([]);
  useEffect(() => {
    let dataset = formValues?.[fromFieldArray];
    // If array already exists
    if (fromFieldArray && dataset) {
      // Fetch data
      setLinkableDataset(dataset);
    }
  }, []);

  return type === "createLinkageId" ? (
    <LinkageIdInput
      schemaProps={schemaProps}
      formValues={formValues}
      formApi={formApi}
      row={row}
      data={linkableDataset}
      input={input}
    />
  ) : // )
  type === "linkageTable" ? (
    <LinkageViewTable
      formApi={formApi}
      data={linkableDataset}
      formValues={formValues}
      schemaProps={schemaProps}
      row={row}
    />
  ) : type === "linkageSelectInput" ? (
    <LinkageSelectInput
      formApi={formApi}
      data={linkableDataset}
      formValues={formValues}
      schemaProps={schemaProps}
      input={input}
      row={row}
    />
  ) : type === "linkageTextInput" ? (
    <LinkageTextInput
      formApi={formApi}
      data={linkableDataset}
      formValues={formValues}
      schemaProps={schemaProps}
      input={input}
      row={row}
    />
  ) : null;
};

export default LinkageTable;
